import tinymce from "tinymce/tinymce";

import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";

require("tinymce/skins/ui/oxide/skin.min.css");

import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/lists";
import "tinymce/plugins/table";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/preview";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/directionality";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/code";

document.addEventListener("DOMContentLoaded", function () {
  const editors = document.querySelectorAll(".tinymce");

  editors.forEach(function (editor) {
    const viewableClass = editor.dataset.viewableClass;
    const viewableId = editor.dataset.viewableId;

    tinymce.init({
      selector: "#" + editor.id,
      skin: false,
      content_css: false,
      // Tighten paragraph/list spacing so pressing Enter (a new <p>) doesn't look
      // double-spaced. Keeping real <p> paragraphs (rather than <br>) is what lets
      // bulleting multiple selected lines turn each line into its own list item.
      content_style: "p, ul, ol { margin: 0 0 0.35rem; } li { margin: 0; }",
      schema: "html5-strict",
      element_format: "html",
      resize: true,
      // Pasting multi-line text turns single line breaks into <br> inside one paragraph,
      // which can't be bulleted (the whole block becomes a single list item). Convert those
      // pasted line breaks into separate paragraphs so the lines can be selected and bulleted.
      paste_postprocess: (editor, args) => {
        args.node.innerHTML = args.node.innerHTML.replace(
          /(<br\s*\/?>\s*)+/gi,
          "</p><p>",
        );
      },
      plugins:
        "image link lists table insertdatetime preview media searchreplace directionality fullscreen visualchars nonbreaking code",
      toolbar:
        "undo redo | bold italic underline strikethrough blockquote backcolor | bullist numlist | outdent indent | link unlink image media | code preview fullscreen",
      images_upload_handler: (blobInfo) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();

          formData.append("discourse_image[attachment]", blobInfo.blob());
          formData.append("discourse_image[viewable_id]", viewableId);

          Spree.ajax({
            url: ["/api", viewableClass, viewableId, "discourse_images"].join(
              "/",
            ),
            type: "POST",
            dataType: "json",
            data: formData,
            processData: false,
            contentType: false,
          })
            .done((response) => resolve(response.url))
            .fail(() => reject("Image upload failed"));
        }),
    });
  });
});
